/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const CollectionIcon = createIcon(
  '0 0 20 20',
  <path d="M5.5 4 5 2h10l-.5 2zm-2 2L4 8h12l.5-2zM2 10l2 8h12l2-8z" />,
);
